import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import idbKeyvalAdapter from "./1_utility";
import devDebug from "../Helpers/debug";
// import { current } from "immer";

const tenderSearchTabAdminKey = `${import.meta.env.VITE_TENDER_SEARCH_TAB_ADMIN_KEY}_${import.meta.env.VITE_VERSION}`;
const tenderSearchTabKey = `${import.meta.env.VITE_TENDER_SEARCH_TAB_KEY}_${import.meta.env.VITE_VERSION}`;
const tenderAwardsSearchTabKey = `${import.meta.env.VITE_AWARDS_SEARCH_TAB_KEY}_${import.meta.env.VITE_VERSION}`;

let tab = {};

tab[tenderAwardsSearchTabKey] = 0;
tab[tenderSearchTabAdminKey] = 0;
tab[tenderSearchTabKey] = 0;

const initialState = {
  tab: tab,
  randomReinit: Math.random(),
  tenderStrategies: [],
  tenderStrategiesLoaded: false,
  applyToAllTabs: false,
  searchViewMode: "schedule",
  scheduleViewModalVisible: false,
  userChoseView: false,
  tenders: [],
  tendersFiltered: [],
  tendersFull: {
    total_pages: 1,
    results: [],
  },
  refreshingTable: true,
  goToFileUploadAddTender: false,
  strategyFilterID: 0,
  checkedAutoConfirmCheckBoxes: [],
  includeAdminColumns: true,
  numTendersToDownload: 0,
  tenderArrayToDownload: [],
  multiXLSXStatus: "",
  totalIterations: 0,
  currentIteration: 0,
  finalArray: [],
  tenderSearchController: null,
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useTenderSearchStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      // ------------------------- GLOBAL REQUEST CONTROLLER ------------------------------
      setTenderSearchController: (tenderSearchController) =>
        set((state) => {
          state.tenderSearchController = tenderSearchController
        }),
      // ------------------------- EXCEL DOWNLOAD ------------------------------
      increaseCurrentIteration: () =>
        set((state) => {
          state.currentIteration++
        }),
      setCurrentIteration: (currentIteration) =>
        set((state) => {
          state.currentIteration = currentIteration
        }),
      setTotalIterations: (totalIterations) =>
        set((state) => {
          state.totalIterations = totalIterations
        }),
      setMultiXLSXStatus: (multiXLSXStatus) =>
        set((state) => {
          state.multiXLSXStatus = multiXLSXStatus
        }),
      setNumTendersToDownload: (numTendersToDownload) =>
        set((state) => {
          state.numTendersToDownload = numTendersToDownload
        }),
      setIncludeAdminColumns: (includeAdminColumns) =>
        set((state) => {
          state.includeAdminColumns = includeAdminColumns
        }),
      resetTenderArrayToDownload: () =>
        set((state) => {
          state.tenderArrayToDownload = []
        }),
      setTenderArrayToDownload: (resultsObject) => //{currentIteration: data.currentIteration, results: resp.results}
        set((state) => {
          state.tenderArrayToDownload = [...state.tenderArrayToDownload, resultsObject]
          if (state.currentIteration === state.totalIterations) {
            state.tenderArrayToDownload.sort((a, b) => a.currentIteration - b.currentIteration)
            state.tenderArrayToDownload = state.tenderArrayToDownload
              .flatMap(obj => obj.results)
              .slice(0, state.numTendersToDownload)
          }
        }),
      // ------------------------- AUTOCONFIRM -------------------------

      checkUncheckAutoConfirmCheckBox: (id) =>
        set((state) => {
          if (state.checkedAutoConfirmCheckBoxes.includes(id)) {
            state.checkedAutoConfirmCheckBoxes = state.checkedAutoConfirmCheckBoxes.filter((x) => x !== id);
          } else {
            state.checkedAutoConfirmCheckBoxes = [...state.checkedAutoConfirmCheckBoxes, id];
          }
        }),
      removeAutoConfirmCheckBox: (id) =>
        set((state) => {
          state.checkedAutoConfirmCheckBoxes = state.checkedAutoConfirmCheckBoxes.filter((x) => x !== id);
        }),
      resetAutoConfirmCheckBoxes: () =>
        set((state) => {
          state.checkedAutoConfirmCheckBoxes = [];
        }),

      // ------------------------- OTHERS ------------------------------

      setStrategyFilterID: (strategyFilterID, strat) =>
        set((state) => {
          state.strategyFilterID = strategyFilterID;
          if (!strat?.cpvs) {
            state.tendersFiltered = state.tenders;
          } else {
            let filteredTenders = [];
            for (let tender of state.tenders) {
              let includeCPV = false;
              for (let cpv of tender.cpv) {
                if (strat.cpvs.includes(cpv)) {
                  includeCPV = true;
                  break;
                }
              }
              if (strat.nuts.includes(tender.nut_code) && includeCPV) {
                filteredTenders.push(tender);
                continue;
              }
            }
            state.tendersFiltered = filteredTenders;
          }
        }),

      setGoToFileUploadAddTender: (goToFileUploadAddTender) =>
        set((state) => {
          state.goToFileUploadAddTender = goToFileUploadAddTender;
        }),
      setRefreshingTable: (refreshingTable) =>
        set((state) => {
          state.refreshingTable = refreshingTable;
        }),
      setTenders: (tenders) =>
        set((state) => {
          state.tendersFull =
            tenders?.results?.length > 0
              ? tenders
              : {
                total_pages: 1,
                results: [],
              };
          state.tenders = tenders?.results?.length > 0 ? tenders.results : [];
          state.numTendersToDownload = tenders?.count || 0
          state.tendersFiltered = tenders?.results?.length > 0 ? tenders.results : [];
        }),
      setUserChoseView: (userChoseView) =>
        set((state) => {
          state.userChoseView = userChoseView;
        }),
      settableQueryParams: (payload) =>
        set((state) => {
          state.tableQueryParams = payload;
        }),
      setScheduleViewModalVisible: (scheduleViewModalVisible) =>
        set((state) => {
          state.scheduleViewModalVisible = scheduleViewModalVisible;
        }),
      setSearchViewMode: (mode) =>
        set((state) => {
          state.searchViewMode = mode;
        }),
      setTab: (payload, section) =>
        set((state) => {
          state.tab[section] = payload;
        }),
      setRandomReinit: () =>
        set((state) => {
          state.randomReinit = Math.random();
        }),
      setApplyToAllTabs: (payload) =>
        set((state) => {
          state.applyToAllTabs = payload;
        }),
      setTenderStrategies: (tabName, payload) =>
        set((state) => {
          state.tenderStrategies = payload;
          const actualTab = { ...state.tab };
          if (actualTab[tabName] >= state.tenderStrategies.length) {
            state.tab[tabName] = 0;
          }
        }),
      setTenderStrategiesLoaded: (payload) =>
        set((state) => {
          state.tenderStrategiesLoaded = payload;
        }),
      resetState: () => {
        useTenderSearchStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) =>
              ![
                "input",
                "tenderStrategies",
                "hideListNutsSearch",
                "tenderStrategiesLoaded",
                "tenderArrayToDownload",
                "multiXLSXStatus",
                "totalIterations",
                "currentIteration"].includes(
                  key
                )
          )
        ),
      name: "tenderSearch",
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[tenderSearchStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[tenderSearchStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[tenderSearchStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[tenderSearchStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[tenderSearchStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[tenderSearchStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },
      onRehydrateStorage: (state) => {
        devDebug(`[tenderSearchStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[tenderSearchStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[tenderSearchStore] Error during rehydration. Store name: "tenderSearchStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[tenderSearchStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
